import { Loader2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";

/* Cloudflare Images procesa las variantes de forma asíncrona: justo después de
 * subir, la URL puede devolver 4xx durante uno o dos segundos. Un <img> normal
 * se queda roto para siempre (área negra sobre fondos oscuros — bug real del
 * cliente en la portada). Este componente reintenta con backoff y muestra un
 * skeleton claro hasta que la variante responde. Estándar para TODAS las
 * previews de imagen recién subida (portadas, fotos de caballo, logos,
 * banners, sponsors). */
export const ResilientImage = ({ src, alt = "", className = "", imgClassName = "", retries = 6, testId }) => {
  const [attempt, setAttempt] = useState(0);
  const [status, setStatus] = useState("loading"); // loading | ok | failed
  const timer = useRef(null);

  useEffect(() => {
    setAttempt(0);
    setStatus("loading");
  }, [src]);
  useEffect(() => () => clearTimeout(timer.current), []);

  if (!src) return null;
  const busted = attempt ? `${src}${src.includes("?") ? "&" : "?"}r=${attempt}` : src;

  return (
    <span className={`relative block overflow-hidden ${className}`} data-testid={testId}>
      {status !== "ok" && (
        <span className="absolute inset-0 bg-[#F5F5F4] animate-pulse flex items-center justify-center" aria-hidden="true">
          {status === "loading" && <Loader2 className="w-4 h-4 animate-spin text-black/25" />}
        </span>
      )}
      <img
        src={busted}
        alt={alt}
        loading="lazy"
        data-testid={testId ? `${testId}-img` : undefined}
        data-loaded={status === "ok" ? "true" : "false"}
        className={`w-full h-full object-cover transition-opacity duration-300 ${status === "ok" ? "opacity-100" : "opacity-0"} ${imgClassName}`}
        onLoad={() => setStatus("ok")}
        onError={() => {
          if (attempt < retries) {
            timer.current = setTimeout(() => setAttempt((a) => a + 1), 1000 * (attempt + 1));
          } else {
            setStatus("failed");
          }
        }}
      />
    </span>
  );
};
